import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=ddcc6bac&scoped=true"
import script from "./Events.vue?vue&type=script&lang=ts"
export * from "./Events.vue?vue&type=script&lang=ts"
import style0 from "./Events.vue?vue&type=style&index=0&id=ddcc6bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc6bac",
  null
  
)

export default component.exports